import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { InteractiveRouting } from '@bittnerdevelopmentgroup/interactive-builder'

console.log("process.env.REACT_APP_CLOUDFRONT_URL", process.env.REACT_APP_CLOUDFRONT_URL)
console.log("process.env.REACT_APP_PAGES_URL", process.env.REACT_APP_PAGES_URL)
console.log("process.env.REACT_APP_PROJECT_TITLE", process.env.REACT_APP_PROJECT_TITLE)


const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <InteractiveRouting 
      title={process.env.REACT_APP_PROJECT_TITLE}
      cloudfrontUrl={process.env.REACT_APP_CLOUDFRONT_URL }
      pagesUrl={process.env.REACT_APP_PAGES_URL}
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
